@let mailLink = '<a href="mailto:digitalsupport@lekkerland.de">digitalsupport@lekkerland.de</a>';
@let telLink = '<a href="tel:+4922349314444">02234/ 9314-444.</a>';
@let message =
  'Ihr Zugang ist aktuell gesperrt. Sie können deshalb keine Bestellungen platzieren.' +
  ' Bitte wenden Sie sich an ' + mailLink + " oder " + telLink +
  ' Wir sind werktags von 8.00 bis 17.00 Uhr für Sie erreichbar.';

<ui-info-bar [showIconClose]="false" theme="error" [message]="message"></ui-info-bar>
